/* tslint:disable */
export const localFr = {
    "BaseUrl": "Url de mise à jour",
    "ConfigPath": "Chemin de téléchargement de la config",
    "content.bootFromServer": "Valeur bouléenne indiquant si il faut mettre à jour l'Url Server",
    "content.serverUrl": "Url du serveur de mise à jour",
    "FirmwarePath": "Chemin de téléchargement du firmware",
    "hardware.audioOut.0.masterSoundLevel": "Le niveau du son principal",
    "hardware.videoOut.0.rotation": "Rotation de l'image (en degré)",
    "LoggingRate": "Fréquence d'envoi des logs d'activités",
    "LogPath": "Chemin de téléversement des logs",
    "MediaPath": "Chemin des medias à télécharger",
    "MinimumFirmwareVersion": "Version minimum du firmware supportée par le player",
    "net.ethernet.dhcp.enabled": "Valeur bouléenne pour indiquer si le player utilise le DHCP",
    "net.ethernet.dnsServers": "Adresse du DNS server",
    "net.ethernet.enabled": "Acivation de la carte réseau",
    "net.ethernet.gateway": "Adresse IP de la passerelle du player",
    "net.ethernet.ip": "Adresse IP configurée pour le player",
    "net.ethernet.netmask": "Masque de sous-réseau du player",
    "net.wifi.authentication": "Mot de passe pour le wifi",
    "net.wifi.enabled": "Activation de la carte wifi",
    "net.wifi.ssid": "Identifiant pour la connection WIFI",
    "PlayLogRate": "Fréquence d'envoi des logs de diffusion",
    "PrefetchDelay": "Fréquence du cycle du préchargement des médias",
    "RebootTime": "Heure de redémarrage du player",
    "RefreshRate": "Fréquence de mise à jour",
    "schedule.reboot.time": "Heure de redémarrage du player",
    "TaskPath": "Chemin de téléchargement des tâches",
    "time.autoUpdate.protocol": "Mode de mise à jour le l'heure",
    "time.timeZone": "Timezone du player",
    "UseDSServerV2": "Valeur bouléenne indiquant si on utilise la version 2 du serveur de mise à jour",
    "DESCRIPTION_FirmwareUpdateTime": "Heure de mise à jour du Firmware automatique",
    "DESCRIPTION_EndUpdate": "Heure maximal de fin de mise à jour",
    "DESCRIPTION_ForceProgram": "Active automatiquement le program 1 au redémarrage",
    "DESCRIPTION_Random": "Activation de la sélection aléatoire des musiques",
    "DESCRIPTION_StartUpdate": "Heure de début de mise à jour",
    "DESCRIPTION_Telnet": "Activation du server telnel local",
    "DESCRIPTION_UpdateInBackground": "Valeur bouléenne indiquant si les mises à jour se font en tâche de fond ou non",
    "DESCRIPTION_VolumeReduction": "Différence de volume entre la musique et les publicités (valeur en décibel (x3))",
    "PLAYER_LIST_ICON_TITLE_SET_DEFAULT": "Définir comme défaut"

}
